import style from './style.module.scss';
import { BiError } from 'react-icons/bi';

export default function ErrorBox({ children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	const renderContent = () => {
		if (typeof children === 'string') {
			const paragraphs = children.split('\n').filter((text) => text.trim() !== '');
			return paragraphs.map((paragraph, index) => (
				<p key={index} className={style.box__paragraph}>
					{paragraph}
				</p>
			));
		}
		return children;
	};

	return (
		<div {...props} className={style.box}>
			<BiError className={style.box__icon} />
			{renderContent()}
		</div>
	);
}
